// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"38ea044df4fcbbc98c1e","147":"e36886249494481c760e","251":"815fb004ac67cf692b3f","352":"44f2c690707b081a675b","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};